import React from 'react';
const FileInput = ({setFileinput,handleFileUpload,title="Save"})=> { 
    return (
        <form class="form-row mt-5" onSubmit={handleFileUpload}>
        <div class="col-md-12">
        <label for="Image">Image</label>
        <div className="row">
            <div className="col-md-8">
              <input 
              onChange={(event)=>{setFileinput(event.target.files[0])}}
              type="file" 
              class="form-control" 
              placeholder="" 
              required
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-sm btn-block btn-success">{title}</button>
            </div>
        </div>
        </div>
      </form>
    );
  }
  
  export default FileInput; 